const getNextDate = (date?: Date) => {
  return new Date((date || new Date()).getTime() + 1000 * 60 * 60 * 24);
}

export default getNextDate;
